// The offline answer for card metadata (W3 deck_cards): the stored
// /cards/images entries of every card in every stored deck, consulted by
// api/cardImages.fetchCardImages when the API is not reachable or the
// request fails. Installed by the offline runtime for offline_owner only.
// Plain module state, no browser global.
import type { CardImage } from '../../api/cardImages'

interface Source {
  lookup: (key: string) => CardImage | undefined
  /** true: do not even try the network (C1 is not online). */
  preferOffline: () => boolean
}

let source: Source | null = null

export function setOfflineCardSource(s: Source | null): void {
  source = s
}

export function offlineCardSource(): Source | null {
  return source
}
